import React from 'react';
import clsx from 'clsx';
import styles from './SegmentedControl.module.scss';

export interface SegmentedOption<T extends string> {
    id: T;
    label: React.ReactNode;
    count?: number;
}

interface SegmentedControlProps<T extends string> {
    options: Array<SegmentedOption<T>>;
    value: T;
    onChange: (value: T) => void;
    size?: 'small' | 'medium';
    className?: string;
}

// Black pill segmented control used across the Enterprise designs (Active / Inactive / All, Sales / Bookings…).
export const SegmentedControl = <T extends string>({
    options,
    value,
    onChange,
    size = 'medium',
    className
}: SegmentedControlProps<T>) => (
    <div className={clsx(styles.root, styles[size], className)}>
        {options.map(option => (
            <button
                key={option.id}
                type="button"
                className={clsx(styles.option, { [styles.selected]: option.id === value })}
                onClick={() => onChange(option.id)}
            >
                {option.label}
                {option.count !== undefined && <span className={styles.count}>{option.count}</span>}
            </button>
        ))}
    </div>
);

export default SegmentedControl;
